<script setup lang="ts">
import { computed, ref, watch } from "vue";

import AngleUpDown from "@/assets/icons/angle-up-down.svg?component";
import { setChartsLocale } from "@/highcharts";
import { ESupportedLocale, useLocalStorageLanguage } from "@/i18n";
import { useTypedIntl } from "@/locales/typed-intl";
import { EMixpanelEvent } from "@/services/mixpanel/mixpanel-events.type";
import { MixpanelService } from "@/services/mixpanel/mixpanel-service";

import Select from "primevue/select";

const intl = useTypedIntl();
const { localStorageLanguage } = useLocalStorageLanguage();

const locale = ref(intl.locale);

const localItems = computed<Array<{ label: string; value: ESupportedLocale }>>(() => {
  return [
    { label: "Français", value: ESupportedLocale.FR },
    { label: "English", value: ESupportedLocale.EN },
  ];
});

watch(locale, () => {
  intl.locale.value = locale.value;
  localStorageLanguage.value = locale.value;

  setChartsLocale(locale.value);

  MixpanelService.trackEvent(EMixpanelEvent.LANGUAGE_CHANGED, {
    language: locale.value,
  });
});
</script>

<template>
  <Select
    v-model="locale"
    data-test-id="select-locale"
    option-label="label"
    option-value="value"
    :options="localItems"
  >
    <template #dropdownicon>
      <AngleUpDown class="shrink-0" />
    </template>
  </Select>
</template>
